import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W12',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M24.73 25.33v-2.97a5.816 5.816 0 0 0 4.36-5.63c0-3.21-2.61-5.82-5.82-5.82-1.16 0-2.24.35-3.15.94-.9-3.87-4.34-6.76-8.48-6.76-4.82 0-8.73 3.91-8.73 8.73 0 3.23 1.76 6.04 4.36 7.55v3.23C3.01 22.87 0 18.7 0 13.82 0 7.39 5.21 2.18 11.64 2.18c4.37 0 8.17 2.41 10.16 5.97.48-.08.97-.15 1.47-.15C28.09 8 32 11.91 32 16.73c0 4.32-3.15 7.9-7.27 8.6zm-13.77-4.24c.4-.7 1.29-.93 1.99-.53l1.6.92v-1.84a1.451 1.451 0 0 1 2.9 0v1.84l1.6-.92c.7-.4 1.59-.16 1.99.53.4.7.16 1.59-.53 1.99l-1.6.92 1.6.92c.7.4.93 1.29.53 1.99-.4.69-1.29.93-1.99.53l-1.6-.92v1.84a1.451 1.451 0 0 1-2.9 0v-1.84l-1.6.92c-.7.4-1.59.16-1.99-.53-.4-.7-.16-1.59.53-1.99l1.6-.92-1.6-.92c-.69-.4-.93-1.29-.53-1.99zM16 25.46A1.451 1.451 0 1 0 14.55 24c0 .8.65 1.46 1.45 1.46z" }
      })]
    );
  }
};